import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstrudexUserGuard  {
  
  currentUser: any;
  roles: Array<string> = [];
  constructor(private authService: AuthService,
    private router: Router)
  {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    return this.authService.user$.pipe(
      map(data => {
        //console.log(data);

        if (data != undefined && data != null){
        this.roles = data["https://transnetyx.com/roles"];
        if (this.roles.includes("Instrudex User"))
          return true;
        else
          return this.RedirectToUnauthorized(state);
      }
      else 
        return this.RedirectToUnauthorized(state);
      })
    );
  }

  RedirectToUnauthorized(state: RouterStateSnapshot){
    this.router.navigate(['/unauthorized'], { queryParams: { returnUrl: state.url }});
    return true;
  }
}
